<mat-drawer-container class="slideout-drawer" [hasBackdrop]="false">
  <mat-drawer
    #cmDrawer
    data-cy="slideout"
    [mode]="'over'"
    position="end"
    [disableClose]="true"
    [style.--desktop-lg-width-percentage]="defaultDesktopLgWidthPercentage"
    [ngStyle]="{ width: drawerConfig?.width || '500px' }"
  >
    <ng-container *ngIf="!isMobile">
      <ng-container *ngTemplateOutlet="drawerContent"></ng-container>
    </ng-container>
  </mat-drawer>

  <mat-drawer-content>
    <ng-content></ng-content>
  </mat-drawer-content>
</mat-drawer-container>

<ng-template #drawerContent>
  <div class="cm-drawer__container flex-col">
    <div *ngIf="drawerConfig?.title" class="cm-drawer__header flex-row flex-centered">
      <div class="cm-drawer__header__title typography__h5">{{ drawerConfig?.title ?? '' | translate }}</div>
      <div *ngIf="!isMobile || drawerConfig?.hasHeaderClose" class="cm-drawer__header__close">
        <cm-icon-button
          icon="close"
          data-cy="slideout-close-icon"
          color="secondary"
          (click)="onClose()"
        ></cm-icon-button>
      </div>
    </div>

    <div cmInfiniteScroll class="cm-drawer__content" (scrollEnd)="onScrollEnd()">
      <ng-template [cdkPortalOutlet]="drawerOutlet"></ng-template>
    </div>

    <div
      *ngIf="
        drawerConfig?.cancelButton ||
        drawerConfig?.secondaryButton ||
        drawerConfig?.primaryButton
      "
      class="cm-drawer__footer"
      [ngClass]="[
        drawerConfig?.showMobileFooter
          ? 'flex-col-reverse mobile-footer'
          : 'flex-row'
      ]"
      data-cy="container-footer-buttons"
    >
      <div class="cm-drawer__footer__cancel cm-drawer__button">
        <cm-basic-button
          [dataCy]="'slideout-cancel'"
          *ngIf="drawerConfig?.cancelButton"
          [color]="drawerConfig?.cancelButton?.color ?? 'primary'"
          [size]="drawerConfig?.cancelButton?.size ?? 'medium'"
          [mode]="drawerConfig?.cancelButton?.mode ?? 'flat'"
          (click)="drawerConfig?.cancelButton?.clickHandler() ?? ''"
        >
          {{ drawerConfig?.cancelButton?.label ?? 'string.cancel' | translate }}
        </cm-basic-button>
      </div>

      <div class="cm-drawer__footer__secondary cm-drawer__button">
        <cm-basic-button
          [dataCy]="'slideout-secondary'"
          *ngIf="drawerConfig?.secondaryButton?.label"
          [color]="drawerConfig?.secondaryButton?.color ?? 'primary'"
          [size]="drawerConfig?.secondaryButton?.size ?? 'medium'"
          [mode]="drawerConfig?.secondaryButton?.mode ?? 'outlined'"
          [disabled]="
            drawerConfig?.secondaryButton?.overrideDisabled
              ? drawerConfig?.secondaryButton.customDisabled
              : disabled
          "
          (click)="onSecondaryEvent()"
        >
          {{ drawerConfig?.secondaryButton?.label ?? '' | translate }}
        </cm-basic-button>
      </div>

      <div class="cm-drawer__footer__primary cm-drawer__button">
        <cm-text-button-with-icon
          [dataCy]="'slideout-primary'"
          *ngIf="drawerConfig?.primaryButton?.label"
          [color]="drawerConfig?.primaryButton.color ?? 'primary'"
          [size]="drawerConfig?.primaryButton.size ?? 'medium'"
          [mode]="drawerConfig?.primaryButton.mode ?? 'filled'"
          [disabled]="isDisabled"
          [isLoading]="
            drawerConfig?.primaryButton?.isLoadingOverrides
              ? isCustomLoading
              : isLoading
          "
          [label]="primaryButtonLabel | translate"
          (click)="
            isDisabled ? '' : drawerConfig?.primaryButton?.clickHandler() ?? ''
          "
        >
        </cm-text-button-with-icon>
      </div>
    </div>
  </div>
</ng-template>
